import { func, string } from 'prop-types';
import React from 'react';
import { DEFAULT_LOCATION_IMAGE } from './constants';
import { LocationImg, LocationImgLink } from './styles';
import { useImageService } from '@kyruus/image-component';

function LocationImage({
  imgUrl = DEFAULT_LOCATION_IMAGE,
  locationUrl,
  onLocationClick
}) {
  const { config } = useImageService();

  return (
    <LocationImgLink
      data-testid="MapCardLocationImage"
      href={locationUrl}
      onClick={onLocationClick}
    >
      <LocationImg
        src={imgUrl}
        alt="Location"
        desiredHeight={150}
        desiredWidth={267}
        enhancementEnabled={config?.enableEnhancement || false}
        data-testid="location-image"
      />
    </LocationImgLink>
  );
}

LocationImage.propTypes = {
  imgUrl: string,
  locationUrl: string.isRequired,
  onLocationClick: func.isRequired
};

export default LocationImage;
